import React from 'react';
import { formatDateLong } from '../utils/calendarConstants';

function CalendarTooltip({ tooltip }) {
  if (!tooltip) return null;

  const label = typeof tooltip.label === 'string' && tooltip.label.includes('-') 
    ? formatDateLong(tooltip.label) 
    : tooltip.label;

  return (
    <div
      className="calendar-tooltip"
      style={{ top: tooltip.top, left: tooltip.left }}
    >
      {label}
    </div>
  );
}

export default CalendarTooltip;

